/* eslint-disable import/prefer-default-export */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { ServiceResponse } from 'leasing-source-shared';
import { CookieService } from 'ngx-cookie';
import { catchError, map, Observable, ReplaySubject, switchMap, tap, throwError } from 'rxjs';
import { ContentObjectDetails } from 'src/app/model/content-object-details.dto';
import { BackEndUrl } from 'src/app/sharedutility/backend-url';
import { LoadDefaultDataService } from '../load-default-data-service/load-default-data.service';

@Injectable({
  providedIn: 'root',
})
export class ContentDetailsService {
  private contentCache$ = new ReplaySubject<ContentObjectDetails[]>(1);

  private cacheInitialized = false;

  private webContent: ContentObjectDetails[];

  private _programContent: ContentObjectDetails[];

  set programContent(content: ContentObjectDetails[]) {
    // eslint-disable-next-line no-underscore-dangle
    this._programContent = content;
    this.contentCache$.next(content);
  }

  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService,
    private loadDefaultDataService: LoadDefaultDataService,
    @Inject(L10N_LOCALE) public locale: L10nLocale
  ) {}

  getWebContentByPosition(contentPosition: string): ContentObjectDetails {
    return this.webContent.find((c) => {
      return c.positionName === contentPosition;
    });
  }

  getProgramContentByPosition(contentPosition: string): ContentObjectDetails {
    // eslint-disable-next-line no-underscore-dangle
    return this._programContent.find((c) => {
      return c.positionName === contentPosition;
    });
  }

  getContentForLS(): Observable<ContentObjectDetails[]> {
    if (!this.cacheInitialized) {      if (!this.loadDefaultDataService.vendorVendorLocations || this.loadDefaultDataService.vendorVendorLocations.length === 0) {
        return throwError(() => new Error("NO VENDOR/VENDOR_LOCATION, POSSIBLE HQ DEALER"));
      }
      this.cacheInitialized = true;
      return this.getContentDetailsForProgram().pipe(
        switchMap(() => {
          return this.contentCache$.asObservable();
        }),
        catchError(() => {
          return this.contentCache$.asObservable();
        })
      );
    }
    return this.contentCache$.asObservable();
  }

  getContentDetailsForProgram(): Observable<ContentObjectDetails[]> {
    const brand = this.cookieService.get('bid');
    const vendor = this.loadDefaultDataService.vendorVendorLocations[0].vendor
    const vendorLocation = this.loadDefaultDataService.vendorVendorLocations[0].vendorLocation
    const payload = {
      IsActive: true,
      Platform: 'Vendor',
      Brand: brand,
      VendorProgramCode: null,
      Locale: this.locale.language,
    };
    const searchContentCall =  this.httpClient.post<ServiceResponse<any>>(`${BackEndUrl.searchContent}`, payload).pipe(
      map((response) => {
        if (response.result) {
          return response.result;
        }
        throw new Error('Service error');
      }),
      tap((content) => {
        this.programContent = content;
      })
    );
    if (brand === 'VFS_CA') {
      return this.pcValuesCall(vendor, vendorLocation).pipe(
        switchMap(brandingType => {
          payload.VendorProgramCode = brandingType === 'BMO' ? null : vendor;
          return searchContentCall;
        })
      )
    }
    return searchContentCall;
  }

  pcValuesCall(vendor: string, vendorLocation: string): Observable<string> {
    return this.httpClient.get<ServiceResponse<any>>(BackEndUrl.pcValues + vendor + '/' + vendorLocation).pipe(
      map(payload => {
        return payload.result.itemValue
      })
    );
  }


  clearContentCache() {
    this.cacheInitialized = false;
    this.contentCache$ = new ReplaySubject<ContentObjectDetails[]>(1);
  }
}
